module.exports = __webpack_public_path__ + "static/img/logo.a5dbe66.png";


//////////////////
// WEBPACK FOOTER
// ./static/fun/logo.png
// module id = 32Za
// module chunks = 0